module.exports = __webpack_public_path__ + "static/media/et.8f800b25.svg";